namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoCampaignForm {
        PromoCampaign: Serenity.StringEditor;
        PromoCampName: Serenity.StringEditor;
    }

    export class PsPromoCampaignForm extends Serenity.PrefixedContext {
        static formKey = 'SalePromoCamp.PsPromoCampaign';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoCampaignForm.init)  {
                PsPromoCampaignForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPromoCampaignForm, [
                    'PromoCampaign', w0,
                    'PromoCampName', w0
                ]);
            }
        }
    }
}
